import { DownOutlined, UpOutlined } from "@ant-design/icons";
import {
  Tree,
  Row,
  Form,
  Input,
  Button,
  Select,
  Popconfirm,
  message,
} from "antd";
import "moment/locale/pt-br";
import { useTemplates } from "../../hooks/useTemplates";
import { useNavigate } from "react-router-dom";

import {
  Container,
  Item,
  Initial,
  Text,
  Infos,
  ButtonAdd,
  ButtonOrder,
} from "./styles";

import { NewModal } from "../NewModal";
import { useEffect, useState } from "react";
import { useTemplateCivilTypes } from "../../hooks/useTemplateCivilTypes";
import { useTemplateOperationTypes } from "../../hooks/useTemplateOperationTypes";

interface ITask {
  id: number;
  type: string;
  title: string;
  duration: number;
  description: string;
  days: string;
  tasks?: ITask[];
  parent_id?: number;
}
interface IData {
  id: string;
  name: string;
  description: string;
  template_civil_id: string;
  template_operation_id: string;
  type: "";
  steps: Array<{
    id: number;
    type: string;
    title: string;
    description: string;
    tasks: ITask[];
  }>;
}

export function Template() {
  let breakRecursive: boolean = false;
  const navigate = useNavigate();
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [confirmStepVisible, setConfirmStepVisible] = useState(false);
  const [projectVisible, setProjectVisible] = useState(false);
  const [stepVisible, setStepVisible] = useState(false);
  const [taskVisible, setTaskVisible] = useState(false);
  const [title, setTitle] = useState("");
  const [selectedStep, setSelectedStep] = useState<number | null>(null);
  const [selectedTasks, setSelectedTasks] = useState<number[] | null>(null);
  const [step, setStep] = useState<any>();
  const [task, setTask] = useState<any>();
  const [auxTask, setAuxTask] = useState<any>(null);
  const [stepForm] = Form.useForm();
  const [taskForm] = Form.useForm();
  const [templateName, setTemplateName] = useState('');
  const [selected1, setSelected1] = useState('');
  const [selected2, setSelected2] = useState('');
  const [textArea, setTextArea] = useState('');
  const [templateForm] = Form.useForm();
  const [isAddTask, setIsAddTask] = useState(false);
  const [selectedDependency, setSelectedDependency] = useState<number | null>(null);
  const [highlightedTaskId, setHighlightedTaskId] = useState<number | null>(null);

  const { createTemplates } = useTemplates()
  const { templateTypes: templateCivilTypes } = useTemplateCivilTypes();
  const { templateTypes: templateOperationTypes } = useTemplateOperationTypes();
  const [data, setData] = useState<IData[]>([
    {
      id: "",
      name: "",
      description: "",
      template_civil_id: "",
      template_operation_id: "",
      type: "",
      steps: [],
    },
  ]);

  const { template_civil_id, description, id, template_operation_id, steps, name } = data[0]
  const newSteps = JSON.stringify(steps)
  const { TextArea } = Input;

  useEffect(() => {
    stepForm.setFieldsValue({
      description: step?.description,
      name: step?.title,
    });
  }, [stepForm, step]);

  useEffect(() => {
    if (task) {
      taskForm.setFieldsValue({
        name: task?.title,
        days: task?.days,
        description: task?.description,
        duration: task?.duration,
      });
    }
  }, [taskForm, task]);

  const handleStepCancel = () => {
    setStepVisible(false);
    setSelectedStep(null);
    setStep(null);
  };

  function handleAddStep(form: { title: string, description: string, index: number }) {
    const aux = data;
    if (form.index >= 0) {
      aux[0].steps[form.index] = {
        ...aux[0].steps[form.index],
        ...form
      };
    } else {
      aux[0]?.steps?.push({
        ...form,
        type: "step",
        id: Math.random(),
        tasks: [],
      });
    }

    setData(aux);
    setStepVisible(false);
  }

  async function handleDeleteStep(index: number) {
    const aux = data;

    if (index > -1) {
      aux[0].steps!.splice(index, 1);
    }

    setData(aux);
    handleStepCancel();
  }

  function findTaskNameById(tasks: ITask[], id: number): string | null {
    for (const task of tasks) {
      if (task.id === id) return task.title;
      if (task.tasks && task.tasks.length > 0) {
        const found = findTaskNameById(task.tasks, id);
        if (found) return found;
      }
    }
    return null;
  }

  function findTaskNameByIdAllSteps(steps: IData["steps"], id: number): string | null {
    for (const step of steps) {
      const found = findTaskNameById(step.tasks, id);
      if (found) return found;
    }
    return null;
  }


  function recursiveTask(
    tasks: ITask[],
    stepIndex: number,
    parents: number[] = []
  ): any {
    return tasks.map((task, index) => {
      const isHighlighted = highlightedTaskId === task.id;
      let parentName: string | null = null;
      if (task.parent_id) {
        parentName = findTaskNameByIdAllSteps(data[0].steps, task.parent_id);
      }
      return {
        key: task.id,
        title: (
          <Item isItem="task" style={isHighlighted ? { background: '#f6ebc6', borderRadius: 6 } : {}}>
            <Initial
              isItem="task"
              onClick={() => {
                setTaskVisible(true);
                setTask(task);
                setTitle("Tarefa");
                setSelectedTasks([...parents, index]);
                setSelectedStep(stepIndex);
              }}
            >
              {task.title.charAt(0)}
            </Initial>
            <Text
              isItem="task"
              onClick={() => {
                setTaskVisible(true);
                setTask(task);
                setTitle("Tarefa");
                setSelectedTasks([...parents, index]);
                setSelectedStep(stepIndex);
              }}
            >
              {task.title} ({ task.days.toLowerCase() === 'calendar_days' ? 'DC' : 'DU' }: { task.duration })
            </Text>
            <ButtonAdd
              onClick={() => {
                taskForm.resetFields();
                setTitle("Nova tarefa dependente");
                setSelectedTasks([...parents, index]);
                setSelectedStep(stepIndex);
                setTaskVisible(true);
                setAuxTask(task);
                setTask(null);
                setIsAddTask(false);
                setSelectedDependency(null);
              }}
            >
              Tarefa encadeada
            </ButtonAdd>
            {parentName && (
              <span
                style={{ marginLeft: 8, color: '#c92846', cursor: 'pointer', fontWeight: 500 }}
                onClick={e => {
                  e.stopPropagation();
                  setHighlightedTaskId(task.parent_id!);
                  setTimeout(() => setHighlightedTaskId(null), 3000);
                }}
              >
                Encadeada com: {parentName}
              </span>
            )}
          </Item>
        ),
        children: task.tasks && task.tasks.length > 0
          ? recursiveTask(task.tasks, stepIndex, [...parents, index])
          : [],
      };
    });
  }

  function recursiveTaskUpdate(currentTask: ITask, form: any) {
    if (currentTask) {
      if (task!.id! === currentTask!.id! && currentTask?.tasks?.length! === 0) {
        const aux = data;

        const index = aux[0].steps![selectedStep!].tasks.indexOf(currentTask);

        aux[0].steps![selectedStep!].tasks[index]! = {
          ...currentTask.tasks![index]!,
          ...form,
          title: form.name,
        };

        setData([...aux]);
      } else if (
        task!.id! === currentTask?.id! &&
        currentTask?.tasks!.length! > 0
      ) {
        message.error("Existem tarefas que dependem dessa!");
      } else {
        currentTask!.tasks!.map((item, index) => {
          if (String(task.id) === String(item.id)) {
            currentTask!.tasks![index] = {
              ...currentTask.tasks![index]!,
              ...form,
              title: form.name,
            };
          } else if (item.tasks?.length! > 0) {
            recursiveTaskUpdate(currentTask?.tasks![index], form);
          }
        });
      }
    }
  }

  function recursiveTaskDelete(currentTask: ITask) {
    if (currentTask) {
      if (task!.id! === currentTask!.id! && currentTask?.tasks?.length! === 0) {
        const aux = data;

        const index = aux[0].steps![selectedStep!].tasks.indexOf(currentTask);

        aux[0].steps![selectedStep!].tasks.splice(index, 1);

        setData(aux);
      } else if (
        task!.id! === currentTask?.id! &&
        currentTask?.tasks!.length! > 0
      ) {
        message.error("Existem tarefas que dependem dessa!");
      } else {
        currentTask!.tasks!.map((item, index) => {
          if (String(task.id) === String(item.id)) {
            if (item?.tasks?.length! > 0) {
              message.error("Existem tarefas que dependem dessa!");
            } else {
              currentTask!.tasks?.splice(index, 1);
              message.success("Deletado");
            }
          } else if (item.tasks?.length! > 0) {
            recursiveTaskDelete(currentTask?.tasks![index]);
          }
        });
      }
    }
  }

  function recursiveTaskAdd(currentTask: ITask, form: any) {
    if (currentTask && !breakRecursive) {
      if (currentTask.id === auxTask.id) {
        currentTask.tasks?.push({
          days: form.days,
          description: form.description,
          duration: form.duration,
          title: form.name,
          type: form.type,
          tasks: [],
          id: Math.random() * 10,
        });
      } else {
        if (currentTask.tasks?.length! > 0) {
          currentTask.tasks!.map((item, index) => {
            if (String(auxTask.id) === String(item.id)) {
              currentTask.tasks![index].tasks!.push({
                days: form.days,
                description: form.description,
                duration: form.duration,
                title: form.name,
                type: form.type,
                tasks: [],
                id: Math.random() * 10,
              });

              breakRecursive = true;
            } else if (item.tasks?.length! > 0) {
              recursiveTaskAdd(currentTask?.tasks![index], form);
            }
          });
        }
      }
    }
  }

  function orderDown(rootIndex: number, index: number, items: any[]) {
    const item = items[index];
    let tempItems = [...items];
    tempItems.splice(index, 1);
    tempItems.splice(index + 1, 0, item);

    const tempData = [...data];
    tempData[rootIndex].steps = tempItems;

    setData(tempData);
  }

  function orderUp(rootIndex: number, index: number, items: any[]) {
    const item = items[index];
    let tempItems = [...items];
    tempItems.splice(index, 1);
    tempItems.splice(index - 1, 0, item);

    const tempData = [...data];
    
    tempData[rootIndex].steps = tempItems;
    setData(tempData);
  }

  // Função recursiva para coletar todas as tarefas e subtasks de uma etapa
  function getAllTasksRecursive(tasks: ITask[], etapaTitle?: string): Array<{ id: number, title: string }> {
    let result: Array<{ id: number, title: string }> = [];
    for (const task of tasks) {
      result.push({ id: task.id, title: etapaTitle ? `${etapaTitle} - ${task.title}` : task.title });
      if (task.tasks && task.tasks.length > 0) {
        result = result.concat(getAllTasksRecursive(task.tasks, etapaTitle));
      }
    }
    return result;
  }

  // Função utilitária para achatar tarefas recursivas para o formato da API
  interface IApiTask {
    id: number;
    title: string;
    description: string;
    duration: number;
    days_type: string;
    parent_id: number | null;
  }

  function flattenTasks(tasks: ITask[], parentId: number | null = null): IApiTask[] {
    return tasks.flatMap(task => {
      const { tasks: children, id, title, description, duration, days, parent_id } = task;
      const flatTask: IApiTask = {
        id,
        title,
        description,
        duration,
        days_type: days,
        parent_id: parent_id !== undefined ? parent_id : parentId,
      };
      if (children && children.length > 0) {
        return [flatTask, ...flattenTasks(children, id)];
      }
      return [flatTask];
    });
  }

  function convertStepsToApiFormat(steps: IData["steps"]): { title: string; description: string; tasks: IApiTask[] }[] {
    return steps.map(step => ({
      title: step.title,
      description: step.description,
      tasks: flattenTasks(step.tasks)
    }));
  }

  return (
    <Container>
      <Form form={templateForm}>
        <Row justify="space-between">
          <Infos >
            <Form.Item
              name="title"
              label="Titulo"
              style={{ width: "100%" }}
              rules={[
                {
                  required: true,
                  message: "Este campo é obrigatório!",
                },
              ]}
              initialValue={data[0].name}
            >
              <Input placeholder="Titulo do projeto" defaultValue={data[0].name}
                onChange={(e) => {
                  setData([{ ...data[0], name: e.target.value }])
                  setTemplateName(e.target.value)
                }}

                value={templateName}
              />
            </Form.Item>

            <Form.Item
              name="civil_type"
              label="Tipo civil"
              style={{
                marginBottom: "25px",
              }}
              rules={[
                {
                  required: true,
                  message: "Este campo é obrigatório!",
                },
              ]}
            >
              <Select
                placeholder="Selecione o tipo civil"
                onChange={(e) => {
                  setData([{ ...data[0], template_civil_id: e }])
                  setSelected1(e)
                }}
                value={selected2}
                style={{ width: "100%" }}
                defaultValue={data[0].template_civil_id}

              >
                {
                  templateCivilTypes.map(templateType => (
                    <Select.Option
                      key={templateType.id}
                      value={templateType.id}
                    >
                      {templateType.title}
                    </Select.Option>
                  ))
                }
              </Select>
            </Form.Item>

            <Form.Item
              name="ops_type"
              label="Tipo operação"
              style={{
                marginBottom: "25px",
              }}
              rules={[
                {
                  required: true,
                  message: "Este campo é obrigatório!",
                },
              ]}
            >
              <Select
                placeholder="Selecione o tipo de operação!"
                onChange={(e) => {
                  setData([{ ...data[0], template_operation_id: e }])
                  setSelected2(e)
                }}
                value={selected1}
                style={{ width: "100%" }}
                defaultValue={data[0].template_operation_id}
              >
                {
                  templateOperationTypes.map(templateType => (
                    <Select.Option
                      key={templateType.id}
                      value={templateType.id}
                    >
                      {templateType.title}
                    </Select.Option>
                  ))
                }
              </Select>
            </Form.Item>

            <Form.Item
              name="description"
              label="Descrição"
              style={{
                marginBottom: "25px",
              }}
              rules={[
                {
                  required: true,
                  message: "Este campo é obrigatório!",
                },
              ]}
            >
              <TextArea
                defaultValue={data[0].description}
                style={{ width: "100%" }}
                placeholder="Nome da descrição"
                autoSize={{ minRows: 4, maxRows: 6 }}
                onChange={(e) => {
                  setData([{ ...data[0], description: e.target.value }])
                  setTextArea(e.target.value)
                }}
                value={textArea}
              />
            </Form.Item>

          </Infos>

          {
            name.length > 0 && (
              <Tree //Arvore
                showIcon={false}
                treeData={data.map((item, index) => {
                  return {
                    key: item.id,
                    title: (
                      <Item isItem="template">
                        <Initial isItem="template">{item.name.charAt(0)}</Initial>
                        <Text isItem="template">{item.name}</Text>
                        <ButtonAdd
                          type="primary"
                          onClick={() => {
                            setTitle("Nova etapa");
                            setStep({ title: '', description: '', index: -1 });
                            stepForm.resetFields();
                            setStepVisible(true);
                          }}
                        >
                          Adicionar Etapa
                        </ButtonAdd>
                      </Item>
                    ),
                    children: item?.steps?.map((step, stepIndex) => {
                      return {
                        key: step.id,
                        title: (
                          <Item isItem="step">
                            <Initial
                              isItem="step"
                              onClick={() => {
                                setStepVisible(true);
                                setStep({ ...data[0].steps![stepIndex], index: stepIndex });
                                setTitle("Etapa");
                              }}
                            >
                              {step.title.charAt(0)}
                            </Initial>
                            <Text
                              isItem="step"
                              onClick={() => {
                                setStepVisible(true);
                                setStep({ ...data[0].steps![stepIndex], index: stepIndex });
                                setTitle("Etapa");
                              }}
                            >
                              {step.title}
                            </Text>
                            <ButtonAdd
                              type={index % 2 === 0 ? "default" : "primary"}
                              onClick={() => {
                                taskForm.resetFields();
                                setTitle("Nova tarefa");
                                setSelectedStep(stepIndex);
                                setTaskVisible(true);
                                setAuxTask(task);
                                setTask(null);
                                setIsAddTask(true);
                                setSelectedDependency(null);
                              }}
                            >
                              Adicionar tarefa
                            </ButtonAdd>
                            {
                              stepIndex > 0 && (
                                <ButtonOrder
                                  onClick={() => orderUp(index, stepIndex, item.steps)}
                                >
                                  <UpOutlined />
                                </ButtonOrder>
                              )
                            }
                            {
                              stepIndex < item?.steps.length - 1 && (
                                <ButtonOrder
                                  onClick={() => orderDown(index, stepIndex, item.steps)}
                                >
                                  <DownOutlined />
                                </ButtonOrder>
                              )
                            }
                          </Item>
                        ),
                        children: recursiveTask(step.tasks, stepIndex),
                      };
                    }),
                  };
                })}
                switcherIcon={
                  <DownOutlined
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      fontSize: "1rem",
                    }}
                  />
                }
                style={{
                  marginRight: 90,
                  marginTop: 30,
                }}
                defaultExpandAll
              />
            )
          }

        </Row>

        <Row
          style={{
            marginLeft: "3rem",
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              if (name !== '' && description !== ''  && template_civil_id !== '' && template_operation_id !== '') {
                if (steps.length <= 0) {
                  return message.warning("Falha, não é possivel criar um template sem fazes");
                }

                const existEt = steps.findIndex(item => item.tasks.length > 0 )

                if(existEt === -1) {
                  return message.warning("Falha, não é possivel criar um template sem tasks");
                }
                // NOVO: converter para o formato da API antes de enviar
                const apiSteps = convertStepsToApiFormat(steps);
                console.log('Steps para API:', apiSteps);
                createTemplates(
                  { name, description, id, template_civil_id, template_operation_id, newSteps: JSON.stringify(apiSteps), type: '' }
                )
                navigate(`/templates/1`);
              }
              else {
                templateForm.validateFields()
              }
            }}
          >
            Salvar
          </Button>
          <Button
            onClick={() => { navigate('/templates/1') }}
          >
            Cancelar
          </Button>
        </Row>
      </Form>

      {
        projectVisible && (
          <NewModal
            visible={projectVisible}
            title={title}
            buttonModalText="Projeto"
            handleCancel={() => { }}
            handleOk={() => { }}
          >
            <Form>
              <Form.Item
                name="name"
                label="Nome"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Input maxLength={50} placeholder="Nome do projeto" />
              </Form.Item>

              <Form.Item
                name="description"
                label="Descrição"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Input maxLength={50} placeholder="Descrição do projeto" />
              </Form.Item>

              <Form.Item
                name="permissions"
                label="Tipo civil"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Select
                  placeholder="Selecione o tipo!"
                  onChange={() => { }}
                  style={{ width: "100%" }}
                >
                  {
                    templateCivilTypes.map(templateType => (
                      <Select.Option
                        key={templateType.id}
                        value={templateType.id}
                      >
                        {templateType.title}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>

              <Form.Item
                name="permissions"
                label="Tipo operação"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Select
                  placeholder="Selecione o tipo"
                  onChange={() => { }}
                  style={{ width: "100%" }}
                >
                  {
                    templateOperationTypes.map(templateType => (
                      <Select.Option
                        key={templateType.id}
                        value={templateType.id}
                      >
                        {templateType.title}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>

              <Form.Item style={{ paddingLeft: "63%" }}>
                <Button type="primary" htmlType="submit" >
                  Salvar
                </Button>
                <Button onClick={() => setProjectVisible(false)}>Cancelar</Button>
              </Form.Item>
            </Form>
          </NewModal>
        )
      }

      {
        stepVisible && (
          <NewModal
            visible={stepVisible}
            title={title}
            buttonModalText="Etapa"
            handleCancel={handleStepCancel}
            handleOk={() => { }}
          >
            <Form
              form={stepForm}
              initialValues={{ ...step }}
              onFinish={(form) => handleAddStep({ ...step, ...form })}
            >
              <Form.Item
                name="title"
                label="Nome"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Input maxLength={50} placeholder="Nome da etapa" />
              </Form.Item>

              <Form.Item
                name="description"
                label="Descrição"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Input maxLength={50} placeholder="Descrição do etapa" />
              </Form.Item>

              <Row style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                <Button type="primary" htmlType="submit">
                  Salvar
                </Button>
                {
                  step.index >= 0 &&
                  <Popconfirm
                    title="Você tem certeza?"
                    visible={confirmStepVisible}
                    onConfirm={async () => {
                      await setConfirmStepVisible(false);
                      await handleDeleteStep(step.index);
                      await setTaskVisible(false);
                    }}
                    onCancel={() => setConfirmStepVisible(false)}
                  >
                    <Button onClick={() => setConfirmStepVisible(true)}>
                      Excluir
                    </Button>
                  </Popconfirm>
                }
              </Row>
            </Form>
          </NewModal>
        )
      }

      {
        taskVisible && (
          <NewModal
            visible={taskVisible}
            title={title}
            buttonModalText="Tarefa"
            handleCancel={() => {
              setTask(null);
              setTaskVisible(false);
              setSelectedTasks(null);
              setSelectedStep(null);
              setIsAddTask(false);
              setSelectedDependency(null);
            }}
            handleOk={() => { }}
          >
            <Form
              form={taskForm}
              onFinish={(form) => {
                const aux = data;
                // NOVA LOGICA PARA DEPENDENCIA
                if (isAddTask && selectedDependency !== null) {
                  // Adiciona a tarefa na etapa atual, com referência de dependência
                  aux[0].steps[selectedStep!].tasks.push({
                    days: form.days,
                    description: form.description,
                    duration: form.duration,
                    title: form.name,
                    type: form.type,
                    tasks: [],
                    id: Math.random() * 10,
                    parent_id: selectedDependency,
                  });
                  setData([...aux]);
                } else if (!selectedTasks) {
                  aux[0]!.steps![selectedStep!].tasks.push({
                    days: form.days,
                    description: form.description,
                    duration: form.duration,
                    title: form.name,
                    type: form.type,
                    tasks: [],
                    id: Math.random() * 10,
                  });
                  setData([...aux]);
                } else if (auxTask?.id || task === null) {
                  if (!auxTask.id) {
                    aux[0].steps![selectedStep!].tasks.push({
                      days: form.days,
                      description: form.description,
                      duration: form.duration,
                      title: form.name,
                      type: form.type,
                      tasks: [],
                      id: Math.random() * 10,
                    });
                  } else {
                    selectedTasks!.forEach((index) => {
                      recursiveTaskAdd(
                        aux[0]!.steps![selectedStep!].tasks![index],
                        form
                      );
                    });
                  }
                  breakRecursive = false;
                  setAuxTask(null);
                  setData([...aux]);
                  setTask({});
                } else if (
                  task &&
                  selectedStep! >= 0 &&
                  selectedTasks?.length! >= 0
                ) {
                  if (selectedTasks?.length === 1) {
                    aux[0].steps![selectedStep!].tasks[selectedTasks[0]] = {
                      ...aux[0].steps![selectedStep!].tasks[selectedTasks[0]],
                      title: form.name,
                      days: form.days,
                      description: form.description,
                      duration: form.duration,
                    };
                  } else {
                    selectedTasks?.forEach((index) => {
                      recursiveTaskUpdate(
                        aux[0]!.steps![selectedStep!].tasks[index]!,
                        form
                      );
                    });
                  }
                  setData([...aux]);
                }
                setTaskVisible(false);
                setIsAddTask(false);
                setSelectedDependency(null);
              }}
            >
              <Form.Item
                name="name"
                label="Nome"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Input maxLength={50} placeholder="Nome da tarefa" />
              </Form.Item>
              <Form.Item
                name="description"
                label="Descrição"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Input maxLength={50} placeholder="Descrição da tarefa" />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duração da tarefa"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Input
                  type="number"
                  min={1}
                  step={1}
                  placeholder="Duração da tarefa"
                />
              </Form.Item>
              <Form.Item
                name="days"
                label="Dias contáveis"
                style={{
                  marginBottom: "25px",
                }}
                rules={[
                  {
                    required: true,
                    message: "Este campo é obrigatório!",
                  },
                ]}
              >
                <Select
                  placeholder="Selecione os dias contáveis"
                  style={{ width: "100%" }}
                >
                  <Select.Option value="working_days">Dias úteis</Select.Option>
                  <Select.Option value="calendar_days">Dias corridos</Select.Option>
                </Select>
              </Form.Item>
              {/* CAMPO DEPENDÊNCIA */}
              {isAddTask && (
                <Form.Item
                  name="dependency"
                  label="Dependência"
                  style={{ marginBottom: "25px" }}
                >
                  <Select
                    placeholder="Selecione uma tarefa para encadear"
                    allowClear
                    value={selectedDependency}
                    onChange={setSelectedDependency}
                    style={{ width: "100%" }}
                  >
                    {/* Lista todas tarefas da etapa atual e anteriores, incluindo subtasks */}
                    {data[0].steps
                      .filter((_, idx) => idx <= selectedStep!)
                      .map((etapa, etapaIdx) => (
                        getAllTasksRecursive(etapa.tasks, etapa.title).map((tarefa) => (
                          <Select.Option key={tarefa.id} value={tarefa.id}>
                            {tarefa.title}
                          </Select.Option>
                        ))
                      ))}
                  </Select>
                </Form.Item>
              )}
              <Form.Item style={{ paddingLeft: "69%" }}>
                <Button type="primary" htmlType="submit">
                  Salvar
                </Button>
                <Popconfirm
                  title="Você tem certeza?"
                  visible={confirmVisible}
                  onConfirm={async () => {
                    const aux = data;
                    await setConfirmVisible(false);
                    selectedTasks!.forEach((index) => {
                      recursiveTaskDelete(
                        aux[0]!.steps![selectedStep!].tasks![index]
                      );
                    });
                    await setTaskVisible(false);
                    setSelectedStep(null);
                    setData([...aux]);
                  }}
                  onCancel={() => setConfirmVisible(false)}
                >
                  <Button
                    onClick={() => {
                      setConfirmVisible(true);
                    }}
                  >
                    Excluir
                  </Button>
                </Popconfirm>
              </Form.Item>
            </Form>
          </NewModal>
        )
      }
    </Container>
  );
}
